import apiClient from '../../lib/axios';

/**
 * List active repositories for the top level of the tree.
 * Returns { data: { repositories } } with name, pathSegment, _id.
 * Use repository name (repositories[].name) wherever the API expects "repository".
 */
export const getActiveRepositories = async () => {
  const { data } = await apiClient.get('/api/repositories/active');
  return data;
};

export default getActiveRepositories;
